import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'avatar',
	templateUrl: './avatar.component.html',
	imports: [CommonModule, FormsModule]
})
export class AvatarComponent implements OnInit {

	@Input() default: any | undefined;
	@Input() size: any | undefined;
	@Input() user: any;
	@Input() origin: any | undefined;

	vm: any = undefined;

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		if (this.vm.size && ['sm', 'lg', 'xl'].indexOf(this.vm.size) === -1) {
			console.error('Invalid size "' + (this.vm.size) + '" for avatar');
			this.vm.size = undefined;
		}

		this.vm.avatarUrl = this.getAvatarUrl();
	}

	getAvatarUrl() {
		if (this.vm.user && this.vm.user.profilePicture && this.vm.user.profilePicture.thumbnailUrl) {
			return this.vm.user.profilePicture.thumbnailUrl + (this.vm.user.moreThumbnails ? '.320x320.jpg' : '');
		} else if (this.vm.user && this.vm.user.fileUrl) {
			return this.vm.user.fileUrl;
		} else {
			switch (this.vm.default) {
				case 'bot':
					return 'https://dqs3afosyxqoy.cloudfront.net/assets/shared/' + (this.vm.origin === 'minudoc.ee' ? 'chatbot-minudoc.png' : 'chatbot-siffi.png');
				case 'doctor':
					return 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/avatar-01.svg';
				case 'doctor2':
					return 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/avatar-02.svg';
				default:
					return false;
			}
		}
	}

}